import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PreloadService {
	preloadImage(src: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			const img = new Image();
			img.src = src;
			if (img.complete) {
				// Image already cached
				resolve();
			} else {
				img.onload = () => resolve();
				img.onerror = (err) => reject(err);
			}
		});
	}
}